import { env } from './env';

export function resolveMediaUrl(value: string | null): string | undefined {
  if (!value) return undefined;
  if (value.startsWith('/homepage/media/') || value.startsWith('/products/media/')) {
    return `${env.apiBaseUrl}${value}`;
  }
  return value;
}
